const BankAccounts = () => import("Core/configuration/bank_accounts/views/BankAccounts");
const BankAccountsForm = () => import("Core/configuration/bank_accounts/views/BankAccountsForm");

export default {
    children: [
        {
            path: "configuration/bank_accounts",
            name: "bank_accounts",
            component: BankAccounts,
            meta: {
                requiresAuth: true,
                title: "lang.bank_accounts",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["bank_accounts.read"],
            },
        },
        {
            path: "configuration/bank_account/:id?",
            name: "bank_account",
            component: BankAccountsForm,
            meta: {
                requiresAuth: true,
                title: "lang.bank_accounts",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["bank_accounts.read"],
            },
        },
    ],
};
